import RentDetailsEditorContainer from './containers/RentDetailsEditorContainer'

export default RentDetailsEditorContainer
